module.exports = __webpack_public_path__ + "static/img/IMG_1256.6f76840.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-konyhahatfal/foter/IMG_1256.jpg
// module id = 580
// module chunks = 0